//@ts-nocheck

import { commonState } from "./common-state.module.ts";
import type { HTMLFormFieldElement } from "./form-field.module.ts";

export async function sendFormData(target, onSuccess, onError) {
    clearErrors(target);
    /**
     * @type HTMLElement
     */
    const preloader = target.querySelector("[data-form-preloader]");
    if (preloader) preloader.classList.remove("display-none");

    const url = target.action;
    const method = target.method;
    const resp = await fetch(url, {
        method: method,
        body: new FormData(target),
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    });
    try {
        if (resp.ok) {
            if (onSuccess) {
                const json = await resp.json();
                onSuccess(json);
            } else {
                window.location.hash = "#modal-closed";
                location.reload();
            }
        } else {
            const error = await resp.json();
            if (resp.status >= 500) {
                throw new Error(error.message);
            }

            if (error.code === "ValidationError") {
                for (let prop in error.validation_errors) {
                    if (error.validation_errors.hasOwnProperty(prop)) {
                        const errorElem =
                            /** @type {HTMLElement} */ target.querySelector(
                                `[data-validation-key="${prop}"]`,
                            );
                        setValidationErrorMessage(
                            errorElem,
                            error.validation_errors[prop],
                        );
                    }
                }
            } else if (onError) {
                onError(target, error);
            } else {
                showFormErrorMessage(target, error.message);
            }
        }
    } catch (error) {
        showFormErrorMessage(
            target,
            commonState.translations["Sorry, something went wrong"],
        );
        console.error(error);
    }
    if (preloader) preloader.classList.add("display-none");
}

/**
 * Показать соообщение об ошибке
 * @param {HTMLElement} target - форма
 * @param {string} message - сообщение
 */
export function showFormErrorMessage(target, message) {
    const formFeedback = target.querySelector("[data-form-feedback]");
    if (formFeedback) {
        formFeedback.classList.remove("display-none");
        const feedbackMessage = formFeedback.querySelector("[data-message]");
        if (feedbackMessage) {
            feedbackMessage.innerHTML = message;
        }
    }
}

/**
 * Показать сообщение об ошибке валидации в элементе формы
 * @param {HTMLElement} errorElem - элемент, содержащий сообщение об ошибке
 * @param {Array | string | null} error - ошибка
 */
export function setValidationErrorMessage(errorElem, error) {
    let message;
    if (Array.isArray(error)) {
        if (error.length > 0) {
            message = error[0];
        }
    } else {
        message = error;
    }
    const span = /** @type {HTMLSpanElement} */ errorElem.querySelector("span");
    if (message) {
        errorElem.classList.remove("display-none");
    } else {
        errorElem.classList.add("display-none");
    }
    span.textContent = message;
}

/**
 * Очистка ошибок формы
 * @param {HTMLElement} target
 */
export function clearErrors(target) {
    const validationErrorElements =
        /** @type {NodeListOf<HTMLElement>} */ target.querySelectorAll(
            `[data-validation-key]`,
        );
    for (const errorElem of validationErrorElements) {
        setValidationErrorMessage(errorElem, null);
    }
    const formFeedback = target.querySelector("[data-form-feedback]");
    if (formFeedback) {
        formFeedback.classList.add("display-none");
        const feedbackMessage = formFeedback.querySelector("[data-message]");
        if (feedbackMessage) {
            feedbackMessage.innerHTML = "";
        }
    }
}

/**
 * Контрол гуард
 */
export function isControlElement(
    element: unknown,
): element is HTMLFormFieldElement {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement
    );
}

/**
 * Добавить валидатор наличия изменений на форму
 * @param {HTMLFormElement} updateFormElement
 */
export function addHasFormValuesChangedValidator(
    updateFormElement: HTMLFormElement,
) {
    const submitButton = <HTMLButtonElement | null>(
        updateFormElement.querySelector("[type='submit']")
    );

    if (!submitButton) return;

    submitButton.disabled = true;

    // Логика основывается на ведении списка полей, чьё значение отличается от начального (значения на момент запуска скрипта)
    const formInitialValue = new Map<string, string>();
    const changedFieldNames = new Set<string>();

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement#elements_that_are_considered_form_controls
     */
    const controlElements = updateFormElement.elements;

    // Собрать начальные значения
    for (const element of controlElements) {
        // INFO: не работает с input[type="image"]
        if (isControlElement(element)) {
            formInitialValue.set(element.name, element.value);
        }
    }

    // На изменение данных формы блокировать\активировать кнопку отправки
    updateFormElement.addEventListener("input", (event) => {
        const element = event.target;
        if (isControlElement(element)) {
            const initialValue = formInitialValue.get(element.name);
            const newValue = element.value;

            if (initialValue === newValue) {
                changedFieldNames.delete(element.name);
            } else {
                changedFieldNames.add(element.name);
            }

            submitButton.disabled = changedFieldNames.size === 0;
        }
    });
}
